import { useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { TagPill } from "../components/TagPill";
import { Header } from "../components/Header";
import { PostCard } from "../components/PostCard";
import { listPublishedPosts, listTags } from "../lib/posts";

export function BlogPage() {
  const [activeTag, setActiveTag] = useState("all");
  const [query, setQuery] = useState("");
  const postsQuery = useQuery({ queryKey: ["posts"], queryFn: listPublishedPosts });
  const tagsQuery = useQuery({ queryKey: ["tags"], queryFn: listTags });

  const posts = postsQuery.data ?? [];
  const tags = tagsQuery.data ?? [];
  const filteredPosts = useMemo(() => {
    const normalized = query.trim().toLowerCase();
    return posts.filter((post) => {
      const matchesTag = activeTag === "all" || post.tags?.some((tag) => tag.slug === activeTag);
      const matchesQuery =
        !normalized ||
        post.title.toLowerCase().includes(normalized) ||
        post.summary.toLowerCase().includes(normalized);
      return matchesTag && matchesQuery;
    });
  }, [activeTag, posts, query]);

  return (
    <>
      <Header />
      <main className="listing-shell">
        <section className="page-hero compact-hero">
          <span>/blog</span>
          <h1>Blog</h1>
          <p>Technical notes, tutorials and lessons from real projects.</p>
        </section>
        <div className="toolbar">
          <div className="tag-filter" aria-label="Filter articles by tag">
            <button className={activeTag === "all" ? "active" : ""} onClick={() => setActiveTag("all")} type="button">
              All
            </button>
            {tags.map((tag) => (
              <button className={activeTag === tag.slug ? "active" : ""} key={tag.slug} onClick={() => setActiveTag(tag.slug)} type="button">
                <TagPill tag={tag} />
              </button>
            ))}
          </div>
          <label className="search-box">
            <span>Search</span>
            <input onChange={(event) => setQuery(event.target.value)} placeholder="Search articles…" value={query} />
          </label>
        </div>
        <div className="post-list">
          {filteredPosts.map((post) => (
            <PostCard key={post.id} post={post} />
          ))}
        </div>
      </main>
    </>
  );
}
